import { render, staticRenderFns } from "./add-dic.vue?vue&type=template&id=f8795be0&scoped=true"
import script from "./add-dic.vue?vue&type=script&lang=js"
export * from "./add-dic.vue?vue&type=script&lang=js"
import style0 from "./add-dic.vue?vue&type=style&index=0&id=f8795be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8795be0",
  null
  
)

export default component.exports